export default __webpack_public_path__ + "static/media/pictogramBeaconSecurity64.39367cc1.svg";